export default {
  cancel: 'Отмена',
  confirm: 'Подтвердить',
  save: 'Сохранить',
  saveChanges: 'Сохранить изменения',
  delete: 'Удалить',
  remove: 'Удалить',
  back: 'Назад',
  continue: 'Продолжить',
  retry: 'Повторить',
  loading: 'Загрузка...',
  error: 'Ошибка',
  success: 'Успешно',
  login: 'Войти',
  signUp: 'Регистрация',
  logout: 'Выйти',
  accountSettings: 'Настройки аккаунта',
  settings: 'Настройки',
  laplace: 'Laplace',
  freeTier: 'Free Tier',
  subscribe: 'Оформить подписку',
  trialDaysLeft_one: 'Остался {{count}} день',
  trialDaysLeft_few: 'Осталось {{count}} дня',
  trialDaysLeft_many: 'Осталось {{count}} дней',
  trialExpired: 'Пробный период истёк',
  trialBannerTitle_one:
    'Внимание: пробный период заканчивается через {{count}} день',
  trialBannerTitle_few:
    'Внимание: пробный период заканчивается через {{count}} дня',
  trialBannerTitle_many:
    'Внимание: пробный период заканчивается через {{count}} дней',
  trialBannerExpiredTitle: 'Пробный период завершился',
  trialBannerDescription:
    'После окончания пробного периода доступ к интеграциям и воркспейсам будет ограничен. Оформите подписку, чтобы сохранить всё.',
  copyright: '© {{year}} Laplace',
  termsOfService: 'Условия использования',
  blog: 'Блог',
  privacyPolicy: 'Политика конфиденциальности',
  refundPolicy: 'Политика возврата',
  trustSecurity: 'Безопасность',
  telegram: 'Telegram',
  x: 'X',
  openAccountMenu: 'Открыть меню аккаунта',
  openNavigation: 'Открыть навигацию',
  cookieConsentTitle: 'Мы используем cookies',
  cookieConsentDescriptionBeforeReject:
    'Нажимая «Принять все cookies», вы соглашаетесь на сохранение cookies на вашем устройстве для улучшения навигации по сайту, анализа использования сайта и улучшения продукта. Вы также можете ',
  cookieConsentRejectLink: 'отклонить необязательные cookies',
  cookieConsentDescriptionBeforePrivacy: '. Подробнее см. в нашей ',
  cookieConsentPrivacyPolicy: 'Политике конфиденциальности',
  cookieConsentDescriptionAfterPrivacy: '.',
  cookieConsentAccept: 'Принять все cookies',
  cookieConsentClose: 'Закрыть уведомление о cookies',
}
